module.exports = __webpack_public_path__ + "static/media/dot-bg.c0e70715.svg";